import type { ComponentProps } from 'react';
// hooks
import { useQuestionAnswerValuesV4 } from 'hooks/useQuestionAnswerValuesV4';
// types
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import { useQuestion } from 'hooks/useQuestion';
import type { TAnyClientQuestionType } from '@hubertai/screening-question-types';

interface Props extends ComponentProps<'div'> {
  disabled?: boolean;
  isMulti?: boolean;
  triggerClassName?: string;
  contentClassName?: string;
  nodeId: string;
  onValueChange: (value: string | string[]) => void;
  value: string | string[];
}

const QuestionAnswersCombobox = ({
  isMulti,
  onValueChange,
  nodeId,

  disabled = false,
  triggerClassName = '',
  contentClassName = '',
  value,
  ...props
}: Props) => {
  const questionConfig = useQuestion(nodeId).questionConfig as TAnyClientQuestionType;
  const languageCode = questionConfig?.language?.c;
  const { isLoading, list } = useQuestionAnswerValuesV4(nodeId, languageCode ? [languageCode] : []);

  if (isLoading) {
    return <span>Loading answers...</span>;
  }

  return (
    <div {...props}>
      <HubertCombobox
        itemName="answer/s"
        isMulti={isMulti}
        items={list}
        onValueChange={(e) => {
          if (onValueChange) {
            onValueChange(e);
          }
        }}
        value={value}
        disabled={disabled}
        triggerClassName={triggerClassName}
        contentClassName={contentClassName}
      />
    </div>
  );
};

export default QuestionAnswersCombobox;
